/**
 * @generated SignedSource<<cbf98dca4240ead4802801f2190e9f72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarSource = "google" | "internal" | "office365";
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
export type EventType = "OCCURRENCE" | "RECURRING" | "SINGLE";
export type ResponseStatusChoices = "accepted" | "declined" | "needsAction" | "none" | "notResponded" | "organizer" | "tentative" | "tentativelyAccepted";
export type StatusChoices = "busy" | "cancelled" | "confirmed" | "free" | "needsAction" | "oof" | "tentative" | "unknown" | "workingElsewhere";
export type WillBeRecordedType = "NO" | "RESTRICTED" | "UNKNOWN" | "YES";
export type MeetingsPanelQuery$variables = {
  end?: string | null;
  start?: string | null;
};
export type MeetingsPanelQuery$data = {
  readonly viewer: {
    readonly dayEvents: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly attendeePersonCount: number;
          readonly calendar: {
            readonly id: string;
            readonly source: CalendarSource;
          };
          readonly color: string | null;
          readonly conferenceCalls: ReadonlyArray<{
            readonly phoneNumber: string | null;
            readonly pin: string | null;
            readonly provider: ConferenceCallProvider;
            readonly url: string;
          }>;
          readonly end: string | null;
          readonly guid: string;
          readonly hasNoteContent: boolean;
          readonly hasUnreadNoteContent: boolean;
          readonly id: string;
          readonly isAllDay: boolean;
          readonly isHidden: boolean | null;
          readonly isOrganizer: boolean | null;
          readonly location: string | null;
          readonly note: {
            readonly stream: {
              readonly hasExternalUsersOrHasRelatedExternalStreams: boolean;
              readonly id: string;
            };
          } | null;
          readonly noteFinished: boolean;
          readonly recurrenceRule: ReadonlyArray<string | null> | null;
          readonly start: string | null;
          readonly status: StatusChoices;
          readonly timeBlockType: string | null;
          readonly title: string;
          readonly type: EventType;
          readonly userResponseStatus: ResponseStatusChoices | null;
          readonly willBeRecorded: WillBeRecordedType;
          readonly " $fragmentSpreads": FragmentRefs<"RecordIcon_event">;
        };
      } | null>;
    };
  };
};
export type MeetingsPanelQuery = {
  response: MeetingsPanelQuery$data;
  variables: MeetingsPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "end"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "start"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "end",
    "variableName": "end"
  },
  {
    "kind": "Variable",
    "name": "start",
    "variableName": "start"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "start",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "end",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Calendar",
  "kind": "LinkedField",
  "name": "calendar",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "source",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "ConferenceCall",
  "kind": "LinkedField",
  "name": "conferenceCalls",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "provider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pin",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "location",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recurrenceRule",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userResponseStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isHidden",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOrganizer",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeBlockType",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNoteContent",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasUnreadNoteContent",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attendeePersonCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteFinished",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStream",
  "kind": "LinkedField",
  "name": "stream",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUsersOrHasRelatedExternalStreams",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willBeRecorded",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MeetingsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "dayEvents",
            "args": (v1/*: any*/),
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "eventsByUserEventFilters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RecordIcon_event"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MeetingsPanelQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "dayEvents",
            "args": (v1/*: any*/),
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "eventsByUserEventFilters",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Note",
                        "kind": "LinkedField",
                        "name": "note",
                        "plural": false,
                        "selections": [
                          (v23/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2ec0f1f8c35b94401a474670f6b2ffbe",
    "id": null,
    "metadata": {},
    "name": "MeetingsPanelQuery",
    "operationKind": "query",
    "text": "query MeetingsPanelQuery(\n  $end: DateTime\n  $start: DateTime\n) {\n  viewer {\n    dayEvents: eventsByUserEventFilters(start: $start, end: $end) {\n      edges {\n        node {\n          id\n          start\n          end\n          title\n          guid\n          type\n          calendar {\n            id\n            source\n          }\n          status\n          conferenceCalls {\n            provider\n            url\n            phoneNumber\n            pin\n          }\n          location\n          recurrenceRule\n          userResponseStatus\n          isHidden\n          isOrganizer\n          isAllDay\n          color\n          timeBlockType\n          hasNoteContent\n          hasUnreadNoteContent\n          attendeePersonCount\n          noteFinished\n          note {\n            stream {\n              id\n              hasExternalUsersOrHasRelatedExternalStreams\n            }\n            id\n          }\n          willBeRecorded\n          ...RecordIcon_event\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment RecordIcon_event on Event {\n  id\n  guid\n  willBeRecorded\n  start\n  status\n  isAllDay\n  timeBlockType\n  conferenceCalls {\n    provider\n    url\n  }\n  calendar {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "c98e0fd77c3222c077a59e46228b0616";

export default node;
